/* bs-contact-form — accordion animado para los FAQs integrados.
   Intercepta el toggle nativo de <details>/<summary> y anima height para abrir/cerrar.
   Mantiene la semantica de <details> para keyboard/screen readers. */

(function () {
  'use strict';

  function setupCard(card) {
    const summary = card.querySelector('.bs-contact-form__faq-summary');
    const answer = card.querySelector('.bs-contact-form__faq-answer');
    if (!summary || !answer) return;

    let animating = false;

    function clearTransitionEnd(handler) {
      answer.removeEventListener('transitionend', handler);
    }

    function animateOpen() {
      animating = true;
      card.setAttribute('open', '');
      const target = answer.scrollHeight;
      answer.style.height = '0px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          answer.style.height = target + 'px';
        });
      });

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        clearTransitionEnd(onEnd);
        answer.style.height = '';
        animating = false;
      }
      answer.addEventListener('transitionend', onEnd);
    }

    function animateClose() {
      animating = true;
      const start = answer.scrollHeight;
      answer.style.height = start + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          answer.style.height = '0px';
        });
      });

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        clearTransitionEnd(onEnd);
        card.removeAttribute('open');
        answer.style.height = '';
        animating = false;
      }
      answer.addEventListener('transitionend', onEnd);
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (animating) return;
      if (card.hasAttribute('open')) {
        animateClose();
      } else {
        animateOpen();
      }
    });
  }

  function init(root) {
    const cards = (root || document).querySelectorAll('.bs-contact-form__faq-card');
    cards.forEach(function (card) {
      if (card.__bsContactFormFaqInit) return;
      card.__bsContactFormFaqInit = true;
      setupCard(card);
    });
  }

  /* Filtra los msg de éxito/error según el hash de la URL.
     Shopify pone `posted_successfully?` global en TODOS los {% form 'contact' %} de la página
     al hacer submit de cualquiera. El redirect incluye `#<form_id>` que sí distingue.
     Si el hash matchea con data-form-msg, lo dejamos; los demás se ocultan. */
  function filterFormMessages(root) {
    const msgs = (root || document).querySelectorAll('.bs-contact-form__msg[data-form-msg]');
    if (msgs.length === 0) return;
    const hash = window.location.hash.replace('#', '');
    msgs.forEach(function (msg) {
      const expected = msg.getAttribute('data-form-msg');
      if (hash && expected && hash !== expected) {
        msg.style.display = 'none';
      }
    });
  }

  /* Validación defensiva del checkbox RGPD del form principal.
     El attr `required` nativo debería bastar, pero algunos navegadores antiguos
     o extensiones lo pueden bypassear. Este listener asegura el bloqueo. */
  function setupConsentValidation(root) {
    const forms = (root || document).querySelectorAll('.bs-contact-form .bs-contact-form__form');
    forms.forEach(function (form) {
      if (form.__bsConsentValidationInit) return;
      form.__bsConsentValidationInit = true;
      const checkbox = form.querySelector('.bs-contact-form__consent-checkbox');
      if (!checkbox) return;
      form.addEventListener('submit', function (event) {
        if (!checkbox.checked) {
          event.preventDefault();
          checkbox.focus();
          checkbox.reportValidity();
        }
      });
    });
  }

  function bootstrap(root) {
    init(root);
    filterFormMessages(root);
    setupConsentValidation(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.bs-contact-form');
    if (section) bootstrap(event.target);
  });
})();
